"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_COLORS = exports.ICON_SIZES = void 0;
var ICON_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
exports.ICON_SIZES = ICON_SIZES;
var ICON_COLORS = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  CRITICAL: "critical"
};
exports.ICON_COLORS = ICON_COLORS;